import * as React from "react";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ width: "50%", display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <Typography
            mb={2}
          variant="body2"
          sx={{ textAlign: "center" }}
          color="#FFF"
        >{`درحال بار گذاری ${Math.round(props.value)}% `}</Typography>
        <LinearProgress
          sx={{ zIndex: 1000000002, width: "100%" }}
          variant="determinate"
          {...props}
        />
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default function ChatProgressBarCm(props) {
  return (
    <div
      style={{
        position: "absolute",
        borderRadius: "32px 32px 4px 4px",
        backgroundColor: "rgba(70, 70, 70, 0.4)",
        backdropFilter: "blur(5px)",
        fontWeight: "bold",
        width: "100%",
        height: "100%",
        zIndex: 1000000001,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        alignContent: "center",
      }}
    >
      <LinearProgressWithLabel value={props.progress ?? 0} />
    </div>
  );
}
